import { useMutation } from "@tanstack/react-query";
import { addNewSubjectToSchedule } from "../../queries/SelectSubjectSchedule";

type TRequestBody = {
  cronogramaId: string;
  date: Date;
  assuntos: string[];
}

const useAddSubjectToSchedule = () => {
  const { mutate, error, isPending, isSuccess, isError, reset } = useMutation({
    mutationKey: ['add-subject-to-schedule'],
    mutationFn: async ({ cronogramaId, date, assuntos }: TRequestBody) => addNewSubjectToSchedule(cronogramaId, date, assuntos),
    retry: false
  });

  return { mutate, error, isPending, isSuccess, isError, reset };
}

export default useAddSubjectToSchedule;
